import { bottomNavigationClasses } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';

import './CoachMarks.scss';
import * as R from 'ramda';
import { debounce } from 'lodash';

import { Config } from '../../config';
import { getOffset } from '../../utils/helpers';

import Lottie from 'react-lottie-player'
import lottieAnim0 from '../../assets/lottie/cm-toggle-live.json';
import lottieAnim1 from '../../assets/lottie/cm-layout.json';
import lottieAnim2 from '../../assets/lottie/cm-graphics.json';
import lottieAnim3 from '../../assets/lottie/cm-go-live.json';


interface CoachMarksProps {
  onAction: any;
}

const CoachMarks = (props: CoachMarksProps) => {

  const producer0Ref = document.getElementById('producer0REF');
  const layoutRef = document.getElementById('layoutToolbarREF');
  const graphicsPanelRef = document.getElementById('graphicsPanelREF');
  const goliveRef = document.getElementById('goliveREF');

  const [marks, setmarks] = useState([
    {
      title: "Add guest presenters to your livestream!",
      text: "Easily add and remove guest presenters, adjust camera and mic settings, and more - all from the video cards.",
      url: "/coachmarks/toggle-presenters.png",
      parent: producer0Ref,
      cursorPos: 'bottom',
      width: 380,
      height: 560,
      top: 0,
      left: 0,
      clip: '',
      anim: lottieAnim0,
      imgSizeW: 380,
      imgSizeH: 295,
    },
    {
      title: "Video Layouts",
      text: "Use the video layouts toolbar below your livestream to change your layouts on the fly.",
      url: "/coachmarks/layout.png",
      parent: layoutRef,
      cursorPos: 'bottom',
      width: 733,
      height: 320,
      top: 0,
      left: 0,
      clip: '',
      anim: lottieAnim1,
      imgSizeW: 358,
      imgSizeH: 329,
    },
    {
      title: "Graphics",
      text: "Brand your stream like a pro! Add lowerthirds, tickers, images, videos and backgrounds to your stream.",
      url: "/coachmarks/graphics-panel.png",
      parent: graphicsPanelRef,
      cursorPos: 'right',
      width: 380,
      height: 560,
      top: 0,
      left: 0,
      clip: '',
      anim: lottieAnim2,
      imgSizeW: 380,
      imgSizeH: 295,
   },
    {
      title: "Go Live",
      text: "When you’re all set and ready to go live, simply click the button on the top right to start livestreaming to all your social channels!",
      url: "/coachmarks/go-live.png",
      parent: goliveRef,
      cursorPos: 'top',
      width: 380,
      height: 560,
      top: 0,
      left: 0,
      clip: '',
      anim: lottieAnim3,
      imgSizeW: 380,
      imgSizeH: 295,
    },
  ]);

  const computePosition = () => {
    const m = R.clone(marks);

    let boundRect = getOffset(m[0].parent);
    m[0].top = boundRect.top - m[0].height - 20;
    m[0].left = Math.max(10, boundRect.left - m[0].width / 3);
    m[0].clip = `polygon(0 0,
        100% 0,
        100% ${boundRect.top}px,
        ${boundRect.left}px 0,
        ${boundRect.left}px ${m[0].parent.offsetHeight + boundRect.top}px,
        ${boundRect.left + m[0].parent.offsetWidth}px ${m[0].parent.offsetHeight + boundRect.top}px,
        ${boundRect.left + m[0].parent.offsetWidth}px ${boundRect.top}px,
        ${boundRect.left}px ${boundRect.top}px,
        ${boundRect.left}px 0,
        100% 0,
        100% 100%,
        0 100% )`;

    boundRect = getOffset(m[1].parent);
    m[1].top = boundRect.top - m[1].height - 20;
    m[1].left = boundRect.left + m[1].parent.offsetWidth/2 - m[1].width / 2;
    m[1].clip = `polygon(0 0,
      100% 0,
      100% ${boundRect.top}px,
      ${boundRect.left}px 0,
      ${boundRect.left}px ${m[1].parent.offsetHeight + boundRect.top}px,
      ${boundRect.left + m[1].parent.offsetWidth}px ${m[1].parent.offsetHeight + boundRect.top}px,
      ${boundRect.left + m[1].parent.offsetWidth}px ${boundRect.top}px,
      ${boundRect.left}px ${boundRect.top}px,
      ${boundRect.left}px 0,
      100% 0,
      100% 100%,
      0 100% )`;

    if (marks[2].parent) {
      boundRect = getOffset(m[2].parent);
      m[2].top = boundRect.top;
      m[2].left = boundRect.left - m[2].width - 20;
      m[2].clip = `polygon(0 0,
          100% 0,
          100% ${boundRect.top - 55}px,
          ${boundRect.left}px 0,
          ${boundRect.left}px ${m[2].parent.offsetHeight + boundRect.top - 55}px,
          ${boundRect.left + m[2].parent.offsetWidth}px ${m[2].parent.offsetHeight + boundRect.top - 55}px,
          ${boundRect.left + m[2].parent.offsetWidth}px ${boundRect.top - 55}px,
          ${boundRect.left}px ${boundRect.top - 55}px,
          ${boundRect.left}px 0,
          100% 0,
          100% 100%,
          0 100% )`;
          }

    boundRect = getOffset(m[3].parent);
    m[3].top = boundRect.top + 70;
    m[3].left = Math.min(window.innerWidth - 10 - m[3].width, boundRect.left - m[3].parent.offsetWidth);
    m[3].clip = `polygon(
      0 0,
      ${boundRect.left - 10}px 0,
      ${boundRect.left - 10}px ${m[3].parent.offsetHeight + 20}px,
      ${window.innerWidth + 10}px ${m[3].parent.offsetHeight + 20}px,
      100% 100%,
      0 100% )`;

    console.log('marks', m);

    setmarks(m);
  }

  useEffect(() => {
    const debouncedHandleResize = debounce(computePosition, 1);

    computePosition();
    window.addEventListener('resize', debouncedHandleResize);
    return () => {
      window.removeEventListener('resize', debouncedHandleResize);
    };
  }, [])

  const [step, setStep] = useState(0);


  const onSelect = (action) => {
    if (action === 1) {
      if (step < marks.length -1) {
        setStep(step + 1);
      }
    } else if (action === -1) {
      if (step > 0) {
        setStep(step - 1);
      }
    } else if (action === 0) {
      // just close => call hide fct in
      props.onAction('close')
    } else {
      // mark tutorial as completed if step=last
      localStorage.setItem('tutorialCompleted', 'true');

      // and close => call hide fct in
      props.onAction('close')

    }
  }

  return (
    <>
    <div className='coachmark-mask' style={{clipPath: marks[step].clip}}></div>
    <div className='coachmark'>

      <div className='coachmark-container' style={{
        width: marks[step].width + 'px',
        height: marks[step].height + 'px',
        top: marks[step].top + 'px',
        left: marks[step].left + 'px',
        }}>
        <div className={'cursor-' + marks[step].cursorPos}></div>
        <div className='close' onClick={() => onSelect(0)}></div>
        { step !== 1 &&
        <>
        <div className='title'>{marks[step].title}</div>
        <div className='text'>{marks[step].text}</div>
        <div className='image' style={{width: marks[step].imgSizeW, height: marks[step].imgSizeH}}>
          <Lottie loop animationData={marks[step].anim} play style={{ width: "100%", height: "100%", color: "white"}} />
        </div>
        <div className='footer'>
          {step > 0 ?
          <div className='btn btn-prev' onClick={() => onSelect(-1)}>PREVIOUS</div> :
          <div className='btn'></div>
          }
          <div className='paging'>{step+1} of {marks.length}</div>
          {step < marks.length -1 &&
          <div className='btn btn-next' onClick={() => onSelect(1)}>NEXT</div>
          }
          {step === marks.length -1 &&
            <div className='btn btn-next' onClick={() => onSelect(99)}>DONE</div>
          }
          </div>
        </>
        }
        { step === 1 &&
        <div className='split'>
          <div className='left'>
            <div className='title'>{marks[step].title}</div>
            <div className='text text-large'>{marks[step].text}</div>
            <div className='footer'>
            {step > 0 ?
            <div className='btn btn-prev' onClick={() => onSelect(-1)}>PREVIOUS</div> :
            <div className='btn'></div>
            }
            <div className='paging'>{step+1} of {marks.length}</div>
            {step < marks.length -1 &&
            <div className='btn btn-next' onClick={() => onSelect(1)}>NEXT</div>
            }
            {step === marks.length -1 &&
              <div className='btn btn-next' onClick={() => onSelect(99)}>DONE</div>
            }
          </div>

          </div>
          <div className='right'>
          <div className='image' style={{width: marks[step].imgSizeW, height: marks[step].imgSizeH}}>
              <Lottie loop animationData={marks[step].anim} play style={{ width: "100%", height: "100%", color: "white"}} />
            </div>
          </div>
        </div>
        }
      </div>
    </div>
    </>
  )
}

export default CoachMarks;

